import React from 'react';

export default function UserInfoIcon() {return(
<svg id='usericon' className='usericon' width="70" height="70" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="48.5" stroke="#807D8E" strokeWidth="3"/>
    <circle cx="49.3347" cy="36.6078" r="11.2273" stroke="#FB2645" strokeWidth="3"/>
    <rect x="32.6562" y="49.0168" width="33.3636" height="24.2727" rx="8.5" stroke="#FB2645" strokeWidth="3"/>
</svg>
);
};